const ApplicationStatusEnum = {
  STACK: "STACK",
  SHORTLIST: "SHORTLIST",
  HIRED: "HIRED",
  REJECTED: "REJECTED",
  HIRING_CANCELLED: "HIRING_CANCELLED"
};

export default ApplicationStatusEnum;
